import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import SvgIcon from '../SvgIcon.js';
var IconIcTableEmpty = props => /*#__PURE__*/
// eslint-disable-next-line react/jsx-props-no-spreading
React.createElement(SvgIcon, _extends({}, props, {
  viewBox: "0 0 60 60",
  iconname: "IconIcTableEmpty"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.52958 55H52.4704C55.52 55 58 52.5083 58 49.4444V10.5556C58 7.49167 55.52 5 52.4704 5H8.52958C5.48002 5 3 7.49167 3 10.5556V49.4444C3 52.5083 5.48002 55 8.52958 55ZM8.52958 49.4444V35.5556H19.5888V49.4444H8.52958ZM36.1775 16.1111V30H25.1183V16.1111H36.1775ZM19.5888 16.1111V30H8.52958V16.1111H19.5888ZM25.1183 49.4444V35.5556H36.1775V49.4444H25.1183ZM41.7071 49.4444V35.5556H52.4732V49.4444H41.7071ZM52.4704 30H41.7071V16.1111H52.4704V30Z",
  fill: "url(#pathTo_Svg__Paint0_Linear_6120_21676)"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "pathTo_Svg__Paint0_Linear_6120_21676",
  x1: "30.5",
  y1: "5",
  x2: "30.5",
  y2: "55",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#ABABAB"
}))));
export { IconIcTableEmpty as default };
//# sourceMappingURL=IconIcTableEmpty.js.map